import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import InsuranceTypeClaimPage from '../../../src/client/pages/insurance/claim';

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([INSURANCE_TYPES.LIFE]);

export const getStaticProps = () => ({
  props: {
    insuranceType: INSURANCE_TYPES.LIFE,
  },
});

export default InsuranceTypeClaimPage;
